import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { RxCross2 } from 'react-icons/rx'
import { CartModalProps } from "../interface"
import "../Header.scss"

export const CartModal=({setCartPopup,cartPopup}:CartModalProps)=>{
    return(
        <Modal className="" isOpen={cartPopup} >
        <ModalHeader className="d-flex justify-content-center border-0 position-relative" >
          <div className="mt-4 fs-30 fw-600">Warning !!</div>
          <div className="position-absolute py-1 px-2 cancel-button-modal" onClick={() => setCartPopup(false)}>
            <RxCross2 style={{ color: '#fff' }} />
          </div>
        </ModalHeader>
        <ModalBody className="rounded-10" style={{ height: 'auto' }}>
          <h3 className='text-center mt-25'>Please empty your cart before logout </h3>
        </ModalBody>
      </Modal>
    )
}